import React from 'react';
import { Link } from 'react-router-dom';
import { AppIcon } from './AppIcon.js';
import { SubscriptionMotion } from './SubscriptionMotion.js';

export const SubscriptionSection: React.FC = () => (
  <section id="cards" className="subscription-section" aria-labelledby="subscription-heading">
    <div className="subscription-copy">
      <span className="eyebrow">VIRTUAL CARDS · EVERYDAY USE</span>
      <h2 id="subscription-heading">
        Your next subscription.
        <br />
        Paid with crypto.
      </h2>
      <p>
        Explore Visa and Mastercard options for AI tools, subscriptions and the things you buy
        online.
      </p>
      <ul className="subscription-use-cases" aria-label="Ways to use your card">
        <li>
          <AppIcon name="services" />
          <span>AI tools &amp; creative apps</span>
        </li>
        <li>
          <AppIcon name="activity" />
          <span>Software &amp; subscriptions</span>
        </li>
        <li>
          <AppIcon name="card" />
          <span>Everyday online purchases</span>
        </li>
      </ul>
      <Link to="/preview/cards" className="ios-btn-primary">
        Preview cards <AppIcon name="arrow" />
      </Link>
      <p className="subscription-note">Preview · Acceptance depends on the card and merchant.</p>
    </div>
    <figure className="subscription-visual">
      <picture>
        <source
          type="image/webp"
          srcSet="/images/crypto-subscriptions-v3-480.webp 480w, /images/crypto-subscriptions-v3-960.webp 960w, /images/crypto-subscriptions-v3-1200.webp 1200w"
          sizes="(max-width: 768px) calc(100vw - 90px), (max-width: 1240px) 44vw, 530px"
        />
        <img
          src="/images/crypto-subscriptions-v3.png"
          alt="A PAY888 black card with lime-green accents and a Mastercard symbol beside a laptop, ChatGPT and Gemini logos, and software and subscription symbols."
          width="1536"
          height="1024"
          loading="lazy"
          decoding="async"
        />
      </picture>
      <SubscriptionMotion />
    </figure>
  </section>
);
